import { render } from "./CardUploadFiles.vue?vue&type=template&id=e4d1dbe6"
import script from "./CardUploadFiles.vue?vue&type=script&lang=js"
export * from "./CardUploadFiles.vue?vue&type=script&lang=js"

import "./CardUploadFiles.vue?vue&type=style&index=0&id=e4d1dbe6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__